import React,{useContext, useEffect,useState} from 'react'
import Axios from 'axios'
import Slot from '../Slot'
import moment from 'moment';
import {makeStyles } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown'
import Tradecodes from '../Tradecodes'
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SearchField from "react-search-field";
import { ButtonContent, Placeholder, Search, Icon} from "semantic-ui-react";
import { JobCard } from '../JobCard';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import userauthStore from "../../../../app/stores/userauthStore";

import config from '../../../../app/api/apiconfig';

const baseURL = config.app.baseUrl




const useStyles = makeStyles((theme) => ({   
    Container : {

    },
    Spinner: {

    },
    Button: {
        cursor: "pointer",
        
    },
    Link: {
        textDecoration: "none",
        color: "black",
        fontWeight: "bold",
        width: "100px",
        height:"50px",
        

    },
    jobContainer: {
        padding: "20px",

    },
    SearchContainer: {
        width: "100%",
        display:"flex"
    },
    SearchIcon: {
        paddingTop: "5px"
    }


}));


export default function RKJobDash() {

    const classes = useStyles();
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [postcode,setPostCode] = useState("");

  


    function handleSearch(event){
        let value = event.target.value.toLowerCase();
        setQuery(value);
    }

    function getData(){
        try
        {
            //
            // var LiveUrl = "https://gilm-clientportal.azurewebsites.net/CP/WorkOrders/GetRkJobs"
            //var testUrl = "https://gilm-clientportal-test.azurewebsites.net/CP/WorkOrders/GetRkJobs"

            let geturl = baseURL + "CP/WorkOrders/GetRkJobs"

            //Axios.get(testUrl)
            Axios.get(geturl)
            .then(response => {
                setLoading(true)
                setData(response.data)
                console.log(response.data);
            }).then(b => {
                setLoading(false)
            });
        }
        catch(ex){
            console.error("An error has occurred: " + ex)
        }
    }

    useEffect(() => {
       getData();
    }, [])
    

    return (
    <div className={classes.Container}>
        <div className={classes.SearchContainer}>
            <Search 
                icon= "none"
                id="input"
                open={false}
                onSearchChange={(event) => {handleSearch(event)}}
                type='text'
                size="mini"
                display="inline"
                placeholder="Search Unscheduled Jobs"
                loading={loading}
          />
                    <Icon className={classes.SearchIcon} name="search"  size="large" color="grey"/>

          </div>
        
        <div className={classes.jobContainer}>
        <Box sx={{ flexGrow: 1 }}>

        <Grid 
            container 
            spacing={2}
            columns={{ xs: 4, sm: 8, md: 12, xl: 12 }}
            >


            {loading ? <Spinner className={classes.Spinner} animation="border" /> : data.filter(x => {
                if(query === ""){
                    return x
                } else if (x["ClientRef"].toLowerCase().includes(query.toLowerCase())){
                    return x
                }}).map((item, i) => (
                    <Grid item xs={2} sm={2} md={2} xl={2} key={i}>
                    <JobCard tradeCode={item.tradeCode} clientRef={item.ClientRef} DateRaised={item.DateRaised}></JobCard>
                    
                    </Grid>
                ))
             }
             </Grid>
             </Box>

            
         

            
        </div>
        
    </div>
 )}

